(() => {
  'use strict';
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
    if (form.querySelector('[data-cs-artwork-pending]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const reference = form.querySelector('[data-cs-design-reference]');
    if (!reference) return;
    if (reference.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reference.setCustomValidity(reference.dataset.error || 'Please specify the design.');
    reference.reportValidity();
    reference.focus();
  }, true);
  document.addEventListener('input', (event) => {
    if (event.target.matches?.('[data-cs-design-reference]')) event.target.setCustomValidity('');
  });
})();